<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'

import { useTasksKanbanLogFilters } from '../model/tasks-kanban-log-filters.hook'

defineOptions({
  name: 'TasksKanbanLogFilters',
})

const {
  filterResetKey,
  searchQuery,
  dateRange,
  handleSearch,
  handleClear,
} = useTasksKanbanLogFilters()
</script>

<template>
  <div class="tasks-kanban-log-filters">
    <div class="tasks-kanban-log-filters__main">
      <div
        :key="filterResetKey"
        class="tasks-kanban-log-filters__general"
      >
        <AppInput
          v-model="searchQuery"
          label="Search"
          placeholder="Type here"
          @keyup:enter="handleSearch"
        />
        <FilterDateRange
          v-model="dateRange"
          label="Date"
          placeholder="Type here"
        />
      </div>
      <div class="tasks-kanban-log-filters__controls">
        <BtnPrimary
          text="Search"
          @click="handleSearch"
        />
        <BtnIcon
          :icon="faFilterCircleXmark"
          color="red"
          tooltip-text="Clear filters"
          @click="handleClear"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TasksKanbanLogFilters.scss" />